import { useEffect } from 'react';

export const useMountEffect = (effect: () => void | (() => void)) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(effect, []);
};
